import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {SettingComponent} from './setting/setting.component';
import {DocComponent} from './doc/doc.component';
import {MainComponent} from './main/main.component';
import {FilterComponent} from './filter/filter.component';
import {ComparisonComponent} from './comparison/comparison.component';

const routes: Routes = [
    {
        path     : 'filter',
        component: FilterComponent
    },
    {
        path     : 'comparison',
        component: ComparisonComponent
    },
    {
        path     : 'doc',
        component: DocComponent
    },
    {
        path     : 'doc/:docCode',
        component: DocComponent
    },
    {
        path     : 'setting',
        component: SettingComponent
    },
    {
        path     : 'main',
        component: MainComponent
    },
    {
        path     : '**',
        component: MainComponent
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
